<section class="section_one">
    <div class="container">

        <div class="ibox">
            <div class="top-fixed">
                <!-- HEADER -->
                <div class="ibox-title d-flex justify-content-between align-items-center">

                    <!-- LEFT TITLE -->
                    <h5 class="dashboard m-0">
                        {{ lastselectedby }} Building List
                    </h5>

                    <!-- RIGHT SIDE BUTTONS -->
                    <div class="d-flex align-items-center gap-2">

                        <!-- COLLEGE BUTTON -->
                        <button class="btn btn-light type-btn" [class.active-type]="selectedType === 'COLLEGE'"
                            (click)="changeType('COLLEGE')">
                            College
                        </button>

                        <!-- SCHOOL BUTTON -->
                        <button class="btn btn-light type-btn" [class.active-type]="selectedType === 'SCHOOL'"
                            (click)="changeType('SCHOOL')">
                            School
                        </button>



                        <!-- FILTER -->
                        <button class="btn btn-warning" (click)="openFilterDialog()">
                            Filter
                        </button>

                        <!-- VIEW TOGGLE -->
                        <button class="btn btn-primary" (click)="toggleView()">
                            {{ viewMode === 'table' ? 'Card View' : 'Table View' }}
                        </button>

                    </div>

                </div>
                <div class="row mb-3 mt-2">

                    <!-- TOTAL BUILDINGS -->
                    <div class="col-md-4">
                        <div class="summary-card total-card">
                            <h6 class="card_detials">Total Buildings</h6>
                            <h3>{{ totalBuildings }}</h3>
                        </div>
                    </div>

                    <!-- NO IMAGE -->
                    <div class="col-md-4">
                        <div class="summary-card image-card">
                            <h6 class="card_detials">No Image</h6>
                            <h3>{{ noImageCount }}</h3>
                        </div>
                    </div>

                    <!-- NO LOCATION -->
                    <div class="col-md-4">
                        <div class="summary-card location-card">
                            <h6 class="card_detials">No Location</h6>
                            <h3>{{ noLocationCount }}</h3>
                        </div>
                    </div>

                </div>
                   <div class="d-flex justify-content mb-3 " *ngIf="!isLoading && viewMode === 'card'">
                        <input type="text" class="form-control" style="width: 500px" placeholder="Search By campus or"
                            [(ngModel)]="searchText" (input)="applySearch(currentFilterParams)"  />
                    </div>

            </div>
          
            <div class="scroll-content">
                <!-- LOADING -->
                <div *ngIf="isLoading" class="text-center p-4">
                    Loading...
                </div>

                <!-- TABLE VIEW -->
                <div *ngIf="!isLoading && viewMode === 'table'">

                    <!-- 🔥 TOP BAR -->
                    <div class="d-flex justify-content-between align-items-center mb-2">

                        <!-- LEFT SIDE EXCEL BUTTON -->
                        <button class="btn btn-success btn-sm" (click)="exportToExcel()">
                            <i class="fa fa-file-excel me-1"></i> Export Excel
                        </button>
                        <!-- Search (RIGHT END) -->
                        <input type="text" class="form-control ms-auto" style="width: 300px" placeholder="Search..."
                            [(ngModel)]="quickFilter" (input)="onQuickFilterChanged()" />

                    </div>

                    <!-- GRID -->
                    <ag-grid-angular class="ag-theme-alpine" style="width: 100%; height: 600px;"
                        [rowData]="filteredData" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
                        [pagination]="true" [rowHeight]="rowHeight" [paginationPageSize]="10"
                        (gridReady)="onGridReady($event)">
                    </ag-grid-angular>

                </div>


                <!-- CARD VIEW -->
                <div *ngIf="!isLoading && viewMode === 'card'" class="row mt-3">
                   
                    <div class="col-md-4 mb-4" *ngFor="let item of filteredData">


                        <div class="card shadow-sm h-100 position-relative building-card">

                            <!-- IMAGE -->
                            <img [src]="getImageUrl(item.buildingId)" (error)="onBuildingImageError($event)"
                                (click)="openBuildingImages(item.buildingId)"
                                class="card-img-top building-img clickable-img" />

                            <!-- BODY -->
                            <div class="card-body pb-5">

                                <h6 class="fw-bold">{{ item.buildingName }}</h6>

                                <p><strong>Campus:</strong> {{ item.campusName }}</p>
                                <p><strong>City:</strong> {{ item.cityName }}</p>
                                <p><strong>State:</strong> {{ item.stateName }}</p>
                                <p><strong>building Fusion Code:</strong> {{ item.buildingFusionCode }}</p>

                            </div>

                            <!-- 🔥 LOCATION ICON -->
                            <div class="location-icon" *ngIf="item.latitude && item.longitude"
                                (click)="openMap(item.latitude, item.longitude)">
                                <img [src]="mapIconPath" alt="Map" />
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>


</section>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>